const styles = theme => ({
  buttonSection: {
    display: 'flex',
    justifyContent: 'center',
    gap: '20px',
    [theme.breakpoints.down('sm')]: {
      padding: '0px 16px',
    },
    marginTop: '40px',
    marginBottom: '8px',
    '& button': {
      minWidth: '139px',
      width: '100%',
      padding: '10px 40px',
      fontWeight: '600',
      fontSize: '16px',
      borderRadius: '4px',
      textTransform: 'none',
      [theme.breakpoints.down('sm')]: {
        padding: '16px 24px',
        fontSize: '12px',
      },
      // '&:hover': {
      //   boxShadow: '1px 2px 10px rgba(0, 0, 0, 0.3)',
      // },
    },
  },
  submitButton: {
    color: '#fff',
    background: theme.palette.primary.main,
  },
  cancelButton: {
    backgroundColor: '#fff',
    border: '1px solid #342D3D',
    color: '#342D3D',
  },
  buttonSectionDelete: {
    display: 'flex',
    justifyContent: 'center',
    gap: '16px',
    '& button': {
      minWidth: '139px',
      fontWeight: '600',
      fontSize: '16px',
      borderRadius: '4px',
      textTransform: 'none',
      padding: '12px 0px',
      width: '100%',
      '&:hover': {
        boxShadow: '1px 2px 10px rgba(0, 0, 0, 0.3)',
      },
    },
    '& $deleteSubmitButton': {
      color: '#fff',
      background: theme.palette.primary.main,
    },
    '& $deleteCancelButton': {
      background: '#FFFFFF',
      color: '#130F26',
      border: '1px solid #130F26',
    },
  },

  deleteSubmitButton: {},
  deleteCancelButton: {},
  subTitle: {
    fontWeight: 500,
    fontSize: '14px',
    color: '#130F26',
  },
  modal: {
    padding: '0px',
  },
  innerModalAccept: {
    position: 'relative',
    padding: '24px',
    '& $crossIconimg': {
      position: 'absolute',
      right: '24px',
      top: '24px',
    },

    '& h1': {
      marginBottom: '16px',
      fontWeight: '600',
      fontSize: '18px',
      color: '#130F26',
    },
    '& h2': {
      marginBottom: '28px',
      fontWeight: '500',
      fontSize: '14px',
      color: '#130F26',
    },
  },
  // subTitle: {
  //   fontSize: '18px',
  // },
  checkBoxTitle: {
    fontWeight: '500',
    lineHeight: '24px',
  },
  crossIconimg: {
    float: 'right',
    cursor: 'pointer',
  },
  modalTitleHead: {
    padding: '24px 24px 0px 24px',
    '&>h1': {
      padding: '0px',
    },
  },
  crossIconBtn: {
    padding: '0px',
  },
  modalContainer: {
    [theme.breakpoints.up('md')]: {
      padding: '0px 24px 24px 24px',
    },
    maxHeight: '75vh',
    // minHeight: '42vh',
    overflowX: 'hidden',
    overflowY: 'auto',
    // borderTop: '1px solid #CED1D6',
    [theme.breakpoints.down('xs')]: {
      borderTop: 'none',
      minHeight: '60vh',
      '& .MuiGrid-item': {
        // padding: '8px 16px',
      },
    },
    '& .MuiGrid-item': {
      padding: '0px',
      marginTop: '16px',
      [theme.breakpoints.down('sm')]: {
        padding: '12px',
      },
    },
  },

  modalContainerModified: {
    padding: '0px',
    width: '100%',
    '& textarea': {
      height: '152px !important',
    },
    [theme.breakpoints.down('xs')]: {
      '& input, & p': {
        fontSize: '16px',
      },
      padding: '0px',
    },
  },
  modalTitleWrapper: {
    [theme.breakpoints.down('xs')]: {
      background: '#F8F8F8',
      padding: '16px 20px !important',
    },
  },
  modalBorder: {
    [theme.breakpoints.up('xs')]: {
      margin: '16px 30px',
    },
    [theme.breakpoints.down('xs')]: {
      border: 'none',
      borderRadius: '0px',
      margin: '0px',
    },
    [theme.breakpoints.up('md')]: {
      margin: '16px',
    },
  },
  modalSectionTittle: {
    marginBottom: '8px',
    [theme.breakpoints.down('xs')]: {
      '& input, & p': {
        fontSize: '16px',
      },
      fontSize: '16px',
      marginBottom: '0px',
    },
  },
  eidContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: '16px',
    margin: '16px',
    border: '1px solid #CED1D6',
    borderRadius: '8px',
    [theme.breakpoints.down('sm')]: {
      margin: '16px 30px',
    },
    [theme.breakpoints.down('xs')]: {
      border: 'none',
      margin: '16px',
      marginTop: '-0px',
      padding: '16px 0px',
      display: 'block',
      '& input, & p': {
        fontSize: '16px',
      },
    },
  },
  cardContainer: {
    margin: '16px',
    [theme.breakpoints.down('sm')]: {
      margin: '28px',
    },
    [theme.breakpoints.down('xs')]: {
      margin: '16px',
    },
  },
  fetchBtn: {
    whiteSpace: 'nowrap',
    padding: '16px 40px',
    height: '56px',
    fontWeight: '600',
    fontSize: '16px',
    background: '#130F26',
    textTransform: 'none',
    marginTop: '25px',
    [theme.breakpoints.down('xs')]: {
      padding: '16px 20px',
      height: '50px',
      fontSize: '14px',
      width: '100%',
      borderRadius: '4px',
    },
    '&:hover': {
      background: '#130F26',
      boxShadow: '1px 2px 10px rgba(0, 0, 0, 0.3)',
    },
  },
  textContainer: {
    width: '100%',
    marginRight: '15px',
  },
  eidCls: {
    flexBasis: '80%',
    marginRight: '10px',
  },

  subBtn: {},
  // Law Firm Modal
  modifiedModal: {
    minWidth: '624px',
    width: '30%',
    [theme.breakpoints.down('sm')]: {
      minWidth: 'auto',
      width: '100%',
    },
  },
  containerModified: {
    padding: '0px',
    [theme.breakpoints.down('sm')]: {
      '& input, & p': {
        fontSize: '16px',
      },
    },
  },
  modifiedHeader: {
    borderBottom: `1px solid ${theme.palette.secondary.disableLightGray}`,
  },
  modifiedContent: {
    padding: '1em 1.5em',
    [theme.breakpoints.down('sm')]: {
      padding: '1em',
      marginRight: '1em',
    },
  },
  modalModified: {
    [theme.breakpoints.down('xs')]: {
      minWidth: 'auto',
      width: '100% !important',
    },
  },
  modalModifiedContent: {
    padding: '0px',
  },
  actionsBtnContainer: {
    margin: '1em 0',
    gridTemplateAreas: '"1 1"',
    '& button': {
      borderRadius: '4px',
      textTransform: 'capitalize',
      fontWeight: 600,
      fontSize: '16px',
      padding: '16px 40px',
      width: '100%',
      [theme.breakpoints.down('sm')]: {
        borderColor: theme.palette.primary.adgmBlack,
      },
    },
  },
  addCls: {
    [theme.breakpoints.down('xs')]: {
      display: 'block',
      width: '100%',
    },
  },
  adgmRedBtn: {
    background: theme.palette.primary.main,
  },
  applicationIdContainer: {
    background: '#F8F8F8',
    padding: '8px 12px 16px',
    fontWeight: 400,
    color: '#8C9099',
    fontSize: '12px',
    '& img': {
      marginLeft: '6px',
      width: '12px',
      height: '12px',
    },
  },
  fontWeight600: {
    fontWeight: '600',
  },
  '@media (max-width:767px)': {
    btnContainer: {
      position: 'fixed',
      bottom: '0',
      left: '0',
      right: '0',
      padding: '16px',
      borderTop: '3px solid #EBEEF3',
      zIndex: '1',
      '& button': {
        width: '100%',
        padding: '16px 40px',
        background: theme.palette.primary.main,
        borderRadius: '4px',
      },
    },
  },

  // validation Modal
  validationModal: {
    minHeight: '255px',
    maxHeight: '70vh',
    maxWidth: '400px',
    [theme.breakpoints.down('sm')]: {
      maxHeight: '100%',
    },
    padding: '24px',
    overflow: 'hidden',
  },
  topSection: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '16px',
  },

  infoSection: {
    display: 'flex',
    alignItems: 'end',
    gap: '15px',
  },
  infoImage: {
    width: '40px',
  },
  Title: {
    fontWeight: '600px',
    fontSize: '18px',
  },
  // subTitle: {
  //   marginBottom: '32px',
  // },
  btnSection: {
    display: 'flex',
    justifyContent: 'space-between',
    '& button': {
      textTransform: 'lowercase',
      '& ::first-letter': {
        textTransform: 'uppercase',
      },
    },
  },
  // cancelButton: {
  //   minWidth: '141px',
  //   minHeight: '48px',
  //   background: '#FFFFFF',
  //   border: '1px solid #130F26',
  //   borderRadius: '4px',
  //   padding: '16px 40px',
  //   [theme.breakpoints.down('sm')]: {
  //     maxWidth: '125px',
  //     minWidth: '120px',
  //     // minHeight: '32px',
  //     padding: '8px 16px',
  //   },
  // },
  // submitButton: {
  //   color: '#FFFFFF',
  //   minWidth: '180px',
  //   minHeight: '48px',
  //  background: theme.palette.primary.main,
  //   border: 'none',
  //   borderRadius: '4px',
  //   padding: '16px 40px',
  //   [theme.breakpoints.down('sm')]: {
  //     maxWidth: '160px',
  //     maxHeight: '48px',
  //     minWidth: '150px',
  //     // minHeight: '32px',
  //     padding: '8px 16px',
  //   },
  // },
});
export default styles;
